import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { useAuth } from "@/context/AuthContext";

export default function AppShell() {
  const { user, logout } = useAuth();
  if (!user || user === false) return null;

  return (
    <div className="min-h-screen bg-background">
      <Sidebar user={user} />
      <div className="md:pl-[260px]">
        <Topbar user={user} onLogout={logout} />
        <main className="p-6 lg:p-10 max-w-[1600px]">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
